// 【検証用・恒久ロジックは一旦コメントアウト。確認後 revert すること】
// 実機で起動動画が出ない問題の切り分け用。localStorage の当日フラグを見ず、
// JSロード(コールドスタート/リロード)ごとに1回だけ表示する。mark が同一ロード内で
// 立つため _authenticated の再横取り(無限ループ)は起きない。
//
// import { hasDoneTodayJst, markDoneTodayJst } from "~/utils/oncePerDay";
//
// /** localStorage のキー: 起動キャンペーン動画を最後に表示した日付（JST 'YYYY-MM-DD'） */
// const LAUNCH_CAMPAIGN_INTRO_DATE_KEY = "lastLaunchCampaignIntroShownDate";
//
// export const shouldShowLaunchCampaignIntro = (): boolean =>
//   !hasDoneTodayJst(LAUNCH_CAMPAIGN_INTRO_DATE_KEY);
//
// export const markLaunchCampaignIntroShown = (): void =>
//   markDoneTodayJst(LAUNCH_CAMPAIGN_INTRO_DATE_KEY);

/** このJSロード内で起動動画を表示済みか（ストレージ非依存・ロード毎にリセット） */
let shownThisLoad = false;

/** このロードでまだ表示していなければ true。 */
export const shouldShowLaunchCampaignIntro = (): boolean => !shownThisLoad;

/** このロードで表示済みとして記録する。 */
export const markLaunchCampaignIntroShown = (): void => {
  shownThisLoad = true;
};
